import { RFXRequest } from '../../interfaces/RFXBackendModel';
import { UIInput } from '../../types/uiTypes';
import { loadRFXRequestQuery } from '../queries/loadRFXRequestQuery';

export interface LoadRFXRequestInput extends UIInput {
  rfxId: string;
  revision: number;
}

export async function loadRFXRequest({ apolloClient, rfxId, revision }: LoadRFXRequestInput): Promise<RFXRequest> {
  const queryVariables = {
    id: {
      id: {
        value: rfxId
      },
      revision: revision
    }
  };

  const response = await apolloClient.query({
    query: loadRFXRequestQuery,
    variables: queryVariables,
    fetchPolicy: 'network-only'
  });

  return response.data.loadRFXRequest.rfxRequest as RFXRequest;
}
